import React, { useState } from 'react';
import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Button from '@mui/material/Button';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import Avatar from '@mui/material/Avatar';
import { deepPurple } from '@mui/material/colors';
import { COLORS } from '../../assets/colors';
import { MEDIAS } from '../../assets/medias';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom'; // Importation du hook useNavigate


const DailyBlock = () => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const navigate = useNavigate();  // Création de la fonction navigate

    const handleLoginClick = () => {
        // Redirige vers la page /dashboard
        // const clientId = "<VOTRE_CLIENT_ID>"; // Remplacez par votre client_id
        // const redirectUri = "<VOTRE_REDIRECT_URI>"; // URL de redirection après l'authentification (côté backend)
        // const authorizeUrl = "https://oauth.intelcia.com/uaa/oauth/authorize";

        // const scope = "openid"; // Scope OAuth
        // const responseType = "code"; // Type de réponse attendu (code d'autorisation)

        // // Construire l'URL d'autorisation avec les paramètres nécessaires
        // const authorizationUrl = `${authorizeUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}`;

        // // Rediriger l'utilisateur vers l'URL d'autorisation
        // window.location.href = authorizationUrl;
        navigate('/dashboard');
    };

    return (
        <Box
            sx={{
                height: 'auto',
                // width: '50%',
                width: { xs: '100%', sm: '50%' }, // Sur mobile, 100% de largeur, sur grand écran, 50%
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                bgcolor: COLORS.WHITE,
                padding: { xs: 2, sm: 3 }, // Padding différent pour les petits écrans


            }}>
            <Box
                sx={{
                    minHeight: '100%',
                    width: '100%',
                    //   marginTop: '10%',
                    // display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',  // Aligne les éléments horizontalement au début
                    alignItems: 'flex-start',      // Aligne les éléments verticalement au début
                }} >
                <img src={MEDIAS.sparkles_auth} alt="Sparkles" style={{ marginBottom: '10px' }} />
                <Typography variant="h3" sx={{
                    fontWeight: 600,
                    fontFamily: 'Inter, Roboto',
                    background: 'linear-gradient(to right, #FC6767 , #EC008C)', // gradient pour le texte
                    WebkitBackgroundClip: 'text',
                    color: 'transparent',

                }}>
                    Your daily<br />companion
                </Typography>
                <Typography color="#4E4B66" variant="caption" sx={{ fontWeight: 400, fontFamily: 'Inter, Roboto' }}>
                    Everything we do, we do it together.
                </Typography>

                <Box sx={{ marginTop: '3%' }}>
                    <Paper
                        elevation={0}
                        component="form"
                        sx={{
                            p: '4px', display: 'flex', alignItems: 'center', width: { xs: '100%', sm: '70%' }, // 100% de largeur sur mobile et 70% sur plus grand écran
                            bgcolor: COLORS.WHITE_BLUE, borderRadius: '4px'
                        }}
                    >
                        <IconButton color={COLORS.GRAY} aria-label="menu">
                            <PersonOutlineOutlinedIcon />
                        </IconButton>
                        <InputBase
                            sx={{ ml: 1, flex: 1, color: COLORS.GRAY }}
                            placeholder="ID/Matricule"
                            inputProps={{ 'aria-label': 'ID/Matricule' }}
                        />
                    </Paper>
                    <Box sx={{ marginTop: '2%' }}></Box>
                    <Paper
                        elevation={0}
                        component="form"
                        sx={{ p: '4px', display: 'flex', alignItems: 'center', width: '70%', bgcolor: COLORS.WHITE_BLUE, borderRadius: '4px', padding: '5px' }}
                    >
                        <IconButton aria-label="menu">
                            <LockOutlinedIcon />
                        </IconButton>
                        <InputBase
                            sx={{ ml: 1, flex: 1, color: COLORS.GRAY }}
                            placeholder="Mot de passe"
                            inputProps={{
                                'aria-label': 'Mot de passe',
                                type: showPassword ? 'text' : 'password', // Change le type selon l'état
                            }}

                        />
                        <IconButton color={COLORS.GRAY} sx={{ p: '10px' }} aria-label="show/hide password"
                            onClick={handleClickShowPassword}
                        >
                            {!showPassword ? <RemoveRedEyeOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </IconButton>
                    </Paper>
                </Box>
                <Box sx={{ marginTop: '2%', display: 'flex', flexDirection: 'row', width: '70%', padding: '2%', justifyContent: 'space-between' }}>
                    <Button variant="text" sx={{ color: "#4E4B66", fontFamily: 'Inter, Roboto !important', textTransform: 'capitalize', fontSize: '11px', paddingLeft: '5%' }}>Mot de passe oublié</Button>
                    <Button
                        onClick={handleLoginClick}
                        sx={{
                            boxShadow: 'none',
                            bgcolor: COLORS.PINK_INTELCIA,
                            borderRadius: '50px',
                            p: '0px 13% 0px 13%',
                            fontSize: "12px",
                            textTransform: 'capitalize',
                            fontFamily: 'Inter, Roboto !important',
                        }} variant="contained" startIcon={<CheckOutlinedIcon />}>
                        Se connecter
                    </Button>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '70%' }}>
                    <Divider>
                        <Typography color="#14142B" variant="caption" sx={{ fontWeight: 400, fontFamily: 'Inter, Roboto' }}>
                            ou
                        </Typography>
                    </Divider>
                    <Button
                        variant="outlined"
                        sx={{
                            width: "100%",
                            // padding: "8px 16px",
                            textTransform: "none",
                            borderRadius: "50px",
                            border: "1px solid #e0e0e0",
                            backgroundColor: "white",
                            color: "black",
                            display: "flex",
                            justifyContent: "flex-start",
                            gap: 2,
                            "&:hover": {
                                backgroundColor: "#ffffff",
                                border: "1px solid #D9DBE9",
                            },
                            margin: '4% 0 6% 0'
                        }}
                    >
                        <Avatar
                            sx={{ bgcolor: deepPurple[500], width: '28px', height: '28px', textAlign: 'center', justifyContent: 'center' }}
                            alt="Profile picture"
                        ><Typography sx={{ fontSize: "11px", display: 'inline' }}>
                                MA
                            </Typography></Avatar>
                        <Box sx={{ flex: 1, textAlign: "left" }}>
                            <Typography sx={{ fontSize: "13px", display: 'inline', color: '#14142B' }}>
                                Continuer étant
                                <Typography sx={{ fontWeight: 500, fontSize: "13px", display: 'inline', color: '#14142B' }}>
                                    {' '}Walid Ennaciri
                                </Typography>
                            </Typography>
                            <Typography
                                sx={{ color: "#5f6368", fontSize: "11px" }}
                            >
                                mohamed.amine@intelcia.com
                            </Typography>
                        </Box>
                        <Box
                            component="img"
                            src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png"
                            sx={{
                                width: 24,
                                height: 24,
                                alignSelf: "center"
                            }}
                            alt="Google logo"
                        />
                    </Button>
                    <Box >
                        <Typography color="#4E4B66" sx={{ fontFamily: 'Inter, Roboto', fontSize: '11px', display: 'inline' }}>
                            En continuant, vous acceptez notre <Typography color="#4E4B66" sx={{ fontFamily: 'Inter, Roboto', fontSize: '11px', display: 'inline', textDecoration: 'underline' }}>
                                politique d'utilisation</Typography> et
                            reconnaissez que vous comprenez la <Typography color="#4E4B66" sx={{ fontFamily: 'Inter, Roboto', fontSize: '11px', display: 'inline', textDecoration: 'underline' }}>
                                politique de confidentialité.</Typography>
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
export default DailyBlock;
